import classNames from "classnames";
import { ReactNode } from "react";

export interface TextBlockProps {
  className?: string;
  label: string;
  value?: string;
  mode?: "vertical" | "horizontal";
  icon?: ReactNode;
  labelClass?: string;
}

export function TextBlock({
  className,
  label,
  value,
  mode = "horizontal",
  icon,
  labelClass,
}: TextBlockProps) {
  const horizontalDisplay = (
    <div className={classNames("flex gap-2 items-center", className)}>
      {icon ? (
        <span>{icon}</span>
      ) : (
        <p className={classNames("text-gray-500 mb-0 text-sm", labelClass)}>
          {label}:
        </p>
      )}
      <p className="font-bold">{value || "-"}</p>
    </div>
  );
  const verticalDisplay = (
    <div className={classNames("flex flex-col", className)}>
      <p className="font-bold m-0 text-lg">{value}</p>
      <span className={classNames("text-gray-500 m-0 text-sm", labelClass)}>
        {label}
      </span>
    </div>
  );
  return mode === "horizontal" ? horizontalDisplay : verticalDisplay;
}

export default TextBlock;
